export default __webpack_public_path__ + "static/media/home.2871b52a.svg";